export const SecondsHandType = {
  STANDARD: "standard",
  SPECIAL: "special",
};
